<template>
  <div class="form-group" :class="{focus, error, disabled, success: !error && value !== '' && !not_check}">
    <input
      v-if="type !== 'textarea'"
      class="form-control form-control--input"
      :class="[classInput]"
      @focus="focusInput(true, true)"
      @blur="focusInput(value === '' || value === null ? false : true, false)"
      :value="value"
      :type="type_input"
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      :disabled="disabled"
      ref="input"
      :style="`background-color:${color}`"
    >
    <textarea
      v-else
      class="form-control form-control--textarea"
      :class="[classInput]"
      @focus="focusInput(true, true)"
      @blur="focusInput(value === '' || value === null ? false : true, false)"
      :value="value"
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      :disabled="disabled"
      ref="input"
      :style="`height: ${height}px;`"
    ></textarea>
    <a
      href="javascript:void(0);"
      v-if="btn_pass"
      @click="type_input==='password' ? type_input='text' : type_input='password'"
      class="show_password"
    >
      <i class="icon-pass-visible-y password-icon" v-if="type_input==='password'"></i>
      <i class="icon-pass-visible-n password-icon" v-else></i>
    </a>
    <!-- <i v-if="!not_check" class="icon-input-accept show_password" :class="{show: !error && value !== ''}"></i> -->
    <!-- <i class="icon-input-accept show_password"></i> -->
    <label v-if="!placeholder" :class="{label_active: value !== null && value !== '' || focused === true}" :style="`background-color:${color}`">
      <slot ></slot>
    </label>
    <label v-else :class="{label_active: value !== null && value !== '' || focused === true}" :style="`background-color:${color}`">
      {{placeholder}}
    </label>
    <span class="focus-border" :class="{input_border: focused === true}"></span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: null,
      default: ''
    },
    /**
     * Error говорит тебе true, когда поле не прошло валидацию,
     * и false если прошло. Error твой бро
     */
    error: {
      type: Boolean,
      default: false
    },
    /**
     * добавляет кнопку "Посмотреть пароль", используется в инпутах с паролем
     */
    btn_pass: Boolean,
    /**
     * Добавляет класс полюшке, какой ты захочешь
     */
    classInput: {
      type: String,
      default: ''
    },
    /**
     * Тип инпута. Если выбрать типа textarea, тогда инпут станет textarea
     */
    type: {
      type: String,
      default: 'text'
    },
    /**
     * Отменяет проверку на успешную валидацию. Не подсвечивает border зелёным
     */
    not_check: Boolean,
    disabled: Boolean,
    placeholder: String,
    height: [Number, String],
    color: String
  },
  data() {
    return {
      // input: '',
      focus: false,
      focused: false,
      showPassword: false,
      type_input: ''
    }
  },
  mounted () {
    this.getType;
  },
  watch: {
    focus(val) {
      // console.log(val)
      val === true ? this.$refs.input.focus() : ''
    }
    // value(val) {
    //   // this.$emit('v-model', val);
    //   console.log(val);
    //   if(val === '') {
    //     this.focused = false
    //   } else this.focused = true
    // }
  },
  computed: {
    getType() {
      this.type_input = this.type;
      return this.type_input;
    }
  },
  methods: {
    focusInput(focusedInputStyle, val) {
      this.focused = focusedInputStyle;
      this.focus = val;
      this.$emit('focusedInput', val);
      val === true ? this.$emit('onFocus') : this.$emit('onBlur')
    }
    // focusedInput() {
    //   if(value === '') {
    //     this.focused = false
    //   } else this.focused = true
    // }
  },
};
</script>

<style lang="scss" scoped>
@import './src/front_white/sass/components/color';
.show_password {
  display: flex;
  align-items: center;
	position: absolute;
	right: 12px;
  top: 50%;
  transform: translateY(-50%);
}
.icon-input-accept {
	bottom: 0.6667rem;

	font-size: 0.8rem;

	transform: scale(0);
}
.show {
	transform: scale(1);
}
label {
	position: absolute;
	top: 7px;
	left: 12px;

	color: rgba($border-main-input, 0.4);
	letter-spacing: 0.0067rem;

	// transform: translateY(-50%);

	pointer-events: none;
}
.label_active {
	top: -7px;

	padding: 0 6px;

	font-size: 10px;

	background-color: #ffffff;
}
.form-group {
	position: relative;

	display: flex;
	// align-items: flex-end;
	// height: 36px;

	font-size: 0.933333rem;
	line-height: 1.57;
	letter-spacing: 0.2px;
	&:hover {
		.form-control {
			border: 1px solid rgba($border-main-input, 0.5);
		}
		label {
			color: rgba($border-main-input, 0.5);
		}
	}
	&.focus {
		.form-control {
			border: 1px solid rgba($border-main-input, 0.75);
		}
		label {
			color: $border-main-input;
		}
	}
	&.error {
		.form-control {
			border: 1px solid $error;
		}
		label {
			color: $error;
		}
  }
  &.success {
    .form-control {
			border: 1px solid $active;
		}
		label {
			color: $active;
		}
  }
  &.disabled {
    opacity: 1 !important;
    box-shadow: none;
    cursor: default;
    .form-control {
      border: 1px solid #F6F6F6;
      background-color: rgba($text-main-input, 0.05);
		}
		label {
      color: rgba($text-main-input, 0.5);
      background-color: transparent;
    }
    .form-control {
      color: rgba($text-main-2, 0.5);
    }
  }
}
.form-control {
	display: block;
	width: 100%;
	padding: 7px 12px;

	color: $text-main-input;

	background: #ffffff;
	border: 1px solid rgba($border-main-input, 0.25);
	border-radius: 5px;
	outline: none;

  appearance: none;

  &--input {
    height: 36px
  }
  &--textarea {
    height: 86px;
    &::-webkit-scrollbar-track {
      background-color: $soft;
      border-radius: 4px;
    }
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $text-soft-light;
      border-radius: 4px;
    }
    &:hover::-webkit-scrollbar-thumb {
      background-color: darken($text-soft-light, 5%);
    }
  }
}



</style>